export default "__VITE_ASSET__BPk1ll0l__"